import { Button, ButtonProps } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { FC } from 'react';

export const SmallButton: FC<ButtonProps> = ({ children, sx, ...props }) => {
  return (
    <Button
      size="small"
      variant="text"
      sx={(theme) => ({
        bgcolor: theme.palette.background.paper,
        '&:hover': {
          bgcolor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.common.main5}`,
        },
        ...((typeof sx === 'function' ? sx(theme) : sx) as SystemStyleObject),
      })}
      {...props}
    >
      {children}
    </Button>
  );
};
